// extracted by mini-css-extract-plugin
export default {"empty-state":"IP2Ph","emptyState":"IP2Ph"};